import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@sitecore-jss/sitecore-jss-react';

const RoleBasedButton = (props) => (
  (props.fields && props.fields.link)
    ? <Link field={props.fields.link} className="btn btn-primary btn-lg btn-block col-md-3" /> : null
);

RoleBasedButton.propTypes = {
  fields: PropTypes.shape({
    link: PropTypes.object,
  }),
};

export default RoleBasedButton;
